import { BaseDB } from './base-db';

export class NizzaDB extends BaseDB {
  constructor() {
    super('nizza', 1);
  }
}
